import classnames from "classnames";
import * as React from 'react';
import style from './Loader.scss';

const syncAnimation = (e: React.AnimationEvent<HTMLElement | SVGElement>) => {
  const [animation] = e.currentTarget?.getAnimations();
  if (animation) animation.startTime = 0;
}

type Props = {
  size?: number,
  absolute?: boolean
};

const Loader = (props: Props) => {
  const { size, absolute } = props;
  let containerStyle = undefined;
  if (size) containerStyle = { '--loader-size': `${size}px` } as React.CSSProperties;
  return (
    <span className={classnames(style.container, absolute && style.absolute)} style={containerStyle} role="progressbar">
      <span className={style.loader} onAnimationStart={syncAnimation}>
        <svg viewBox="22 22 44 44">
          <circle
            className="MuiCircularProgress-circle MuiCircularProgress-circleIndeterminate css-14891ef"
            cx="44"
            cy="44"
            r="20.2"
            fill="none"
            strokeWidth="3.6"
            onAnimationStart={syncAnimation}
          />
        </svg>
      </span>
    </span>
  );
};

export default Loader;
